//Imports
import Vue from "vue";
import Vuex from "vuex";

//Use
Vue.use(Vuex);

//Build the store
export default new Vuex.Store({
	state: {
        user: null,
        users: [],
        appLoading: true,
        constants: {},
        inspectionFilters: null,
        payrollFilters: null,
        partFilters: null,
        timelogFilters: null,
    },

    mutations: {
        login(state, user) {
            state.user = user;
        },

        logout(state){
            //Null out the user
            state.user = null;
        },

        appLoading(state){
            //Set the flag
            state.appLoading = false;
        },

        users(state, users){
            //Set the flag
            state.users = users;
        },

        constants(state, constants){
            //Set it
            state.constants = constants;
        },

        inspectionFilters(state, inspectionFilters){
            //SEt it
            state.inspectionFilters = inspectionFilters;
        },

        payrollFilters(state, payrollFilters){
            //SEt it
            state.payrollFilters = payrollFilters;
        },

        partFilters(state, partFilters){
            //SEt it
            state.partFilters = partFilters;
        },

        timelogFilters(state, timelogFilters){
            //Set it
            state.timelogFilters = timelogFilters;
        }
    },

	// modules: {
 //        subcontractor,
 //        JsaStoreModule,
 //        tableFilters,
	// }
});